import type {
    LoadingDotsPatternSpec,
    LoadingDotsMotionSpec,
    LoadingDotsSizeSpec,
    LoadingDotsMotion,
    LoadingDotsSize
} from "./type";
import type {
    LoadingDotsPattern
} from "../../type";

export const LOADING_DOTS_SIZES: Record<LoadingDotsSize, LoadingDotsSizeSpec> = {
    large: {
        gap: "indicator",
        scale: 2
    },
    small: {
        gap: "subtract",
        scale: 1
    }
};

export const LOADING_DOTS_RADIUS_DIVISOR = 4;

export const LOADING_DOTS_MOTIONS: Record<LoadingDotsMotion, LoadingDotsMotionSpec> = {
    fill: {
        stops: [
            {
                tone: "dark",
                at: 0
            },
            {
                tone: "dark",
                at: 0.3
            },
            {
                tone: "mid",
                at: 0.55
            },
            {
                tone: "dim",
                at: 0.8
            },
            {
                tone: "dim",
                at: 1
            }
        ],
        duration: "loop"
    },
    trail: {
        stops: [
            {
                tone: "dark",
                at: 0
            },
            {
                tone: "mid",
                at: 0.12
            },
            {
                tone: "dim",
                at: 0.26
            },
            {
                tone: "dim",
                at: 1
            }
        ],
        duration: "spin"
    },
    wave: {
        stops: [
            {
                tone: "dark",
                at: 0
            },
            {
                tone: "mid",
                at: 0.28
            },
            {
                tone: "dim",
                at: 0.56
            },
            {
                tone: "dim",
                at: 1
            }
        ],
        duration: "loop"
    }
};

export const LOADING_DOTS_PATTERNS: Record<LoadingDotsPattern, LoadingDotsPatternSpec> = {
    honeycomb: {
        motion: "trail",
        columns: 4,
        period: 8,
        steps: [
            null,
            0,
            7,
            null,
            1,
            null,
            null,
            6,
            2,
            null,
            null,
            5,
            null,
            3,
            4,
            null
        ]
    },
    lattice: {
        motion: "trail",
        columns: 3,
        period: 8,
        steps: [
            0,
            7,
            6,
            1,
            null,
            5,
            2,
            3,
            4
        ]
    },
    noise: {
        motion: "trail",
        columns: 4,
        period: 16,
        steps: [
            5,
            13,
            2,
            10,
            0,
            7,
            12,
            3,
            9,
            1,
            15,
            6,
            11,
            4,
            8,
            14
        ]
    },
    scatter: {
        motion: "trail",
        columns: 3,
        period: 9,
        steps: [
            6,
            2,
            8,
            4,
            0,
            1,
            7,
            3,
            5
        ]
    },
    checker: {
        motion: "wave",
        columns: 4,
        period: 2,
        steps: [
            0,
            1,
            0,
            1,
            1,
            0,
            1,
            0,
            0,
            1,
            0,
            1,
            1,
            0,
            1,
            0
        ]
    },
    columns: {
        motion: "wave",
        columns: 3,
        period: 3,
        steps: [
            0,
            2,
            1,
            0,
            2,
            1,
            0,
            2,
            1
        ]
    },
    dither: {
        motion: "wave",
        columns: 4,
        period: 7,
        steps: [
            0,
            6,
            5,
            4,
            6,
            5,
            4,
            3,
            5,
            4,
            3,
            2,
            4,
            3,
            2,
            1
        ]
    },
    halftone: {
        motion: "fill",
        columns: 4,
        period: 3,
        steps: [
            1,
            2,
            2,
            1,
            2,
            0,
            0,
            2,
            2,
            0,
            0,
            2,
            1,
            2,
            2,
            1
        ]
    },
    rain: {
        motion: "wave",
        columns: 4,
        period: 4,
        steps: [
            0,
            2,
            3,
            1,
            3,
            1,
            2,
            0,
            2,
            0,
            1,
            3,
            1,
            3,
            0,
            2
        ]
    },
    ripple: {
        motion: "wave",
        columns: 3,
        period: 3,
        steps: [
            1,
            2,
            1,
            2,
            0,
            2,
            1,
            2,
            1
        ]
    }
};
